import { Component, OnInit, ElementRef } from '@angular/core';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { OptionService } from '../../services/option.service';

import { OptionsControlBaseComponent } from '../options-control-base/options-control-base.component';

import { ControlTypeName } from '../../types/control-type-name';
import { ControlValidateMoment } from '../../types/validator.types';
import { OptionItem } from '../../types/control.types';

@Component({
  selector: 'df-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css']
})
export class RadioComponent extends OptionsControlBaseComponent<OptionItem> implements OnInit {
  type = ControlTypeName.radio;

  constructor(protected commonConfig: DynamicFormCommonConfig, protected service: OptionService) {
    super(commonConfig, service);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  // checkäºä»¶æ¥åå¼
  select(event: any) {
    this.model.value = event.target.value;
    this.validateAtMoment(ControlValidateMoment.Input);
    this.validateAtMoment(ControlValidateMoment.Change);

    this.broadControlValueChange();
  }

  getCheckedText(): string {
    if (!this.showOptions) {
      return '';
    }

    const checkedOption = this.showOptions.find((s) => s.id === this.model.value);
    if (checkedOption) {
      return checkedOption.text;
    }
    return '';
  }
}
